import React, { FC } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import List from 'components_new/pages/internal/List'
import Lists from 'components_new/pages/internal/Lists'

import {
  useAccountSettings,
  useIsAuthenticated
} from 'redux/hooks/SignedInAccount'

import AuthRoute from './AuthRoute'

const Routes: FC = () => {
  const isAuthenticated = useIsAuthenticated()
  const { isHomepal } = useAccountSettings()

  return (
    <Switch>
      <AuthRoute
        isAuthenticated={isAuthenticated && isHomepal}
        Component={() => <List />}
        path={'/lists/:id'}
      />
      <AuthRoute
        isAuthenticated={isAuthenticated && isHomepal}
        Component={() => <Lists />}
        path={'/lists'}
      />
      <Route path={'/lists/*'}>
        <Redirect to="/lists" />
      </Route>
    </Switch>
  )
}

export default Routes
